/** What the app knows right now: the site, who's signed in, the office, and what's open. */
import type { ActivityEntry, BookPageResponse, DocumentInfo, EstateRecordResponse, EstateRow, IndexBookInfo, IndexSectionInfo, Me, OfficeInfo, PageRef, Perms, PrintJob, SiteInfo } from '@imagesync/core';

export type Tab = 'index' | 'bookpage' | 'estates';
export interface SeqItem { page: PageRef; label: string; doc?: DocumentInfo; section?: (IndexSectionInfo & { entries?: IndexEntry[] }) | null; n?: number }
export interface IndexEntry { surname: string; given: string; book: number | string | null; page: number | string | null }
export interface Seq {
  type: 'book' | 'index' | 'estate';
  items: SeqItem[];
  book?: BookPageResponse['book']; document?: DocumentInfo; prevPage?: string | null; nextPage?: string | null; firstPage?: string; lastPage?: string;
  index?: IndexBookInfo; series?: string; seriesLabel?: string; volumeBook?: string;
  record?: EstateRecordResponse;
}
export interface FormState { which: string; series: string; last: string; init: string; corp: boolean; bpType: string; bpBook: string; bpPage: string }
export interface EstateQuery { last: string; sounds: boolean; first: string; docket: string; type: string; muni: string; from: string; to: string; deleted?: boolean }

export const S = {
  site: null as SiteInfo | null,
  me: null as Me | null,
  office: null as OfficeInfo | null,
  tab: {} as Record<string, Tab>,
  forms: {} as Record<string, FormState>,
  mem: {} as Record<string, Partial<Record<Tab, { seq: Seq | null; idx: number; record: EstateRow | null } | null>>>,
  cards: {} as Record<string, { idx: string; bp: string } | null>,
  seq: null as Seq | null,
  idx: 0,
  record: null as EstateRow | null,
  rangeKey: null as string | null,
  tool: 'pan' as 'pan' | 'highlight' | 'redact',
  gray: false, invert: false, viewAsPublic: false,
  es: {
    q: null as EstateQuery | null, rows: [] as EstateRow[], total: 0, restrictedHidden: null as number | null,
    page: 1, size: 25, sort: { key: 'docket', dir: 'desc' as 'asc' | 'desc' }, show: false, ran: false, selected: null as string | null, loading: false,
  },
  jobs: [] as PrintJob[],
  activity: [] as ActivityEntry[],
  hinted: {} as Record<string, boolean>,
};

export const me = () => S.me!;
export const perms = (): Perms => S.me?.perms ?? ({ printers: [] } as unknown as Perms);
export const can = (k: keyof Perms): boolean => !!perms()[k];
export const isGuest = () => S.me?.user?.kind === 'guest';
export const role = () => S.me?.user?.role ?? 'Public';
export const canAdmin = () => !isGuest() && (role() === 'Admin' || role() === 'Cashier');
export const isAdmin = () => !isGuest() && role() === 'Admin';
export const office = () => S.office!;
export const officeSlug = () => S.me?.office ?? S.office?.slug ?? '';
export const displayName = () => (isGuest() ? 'Guest terminal' : S.me?.user?.name ?? '');
export const hasModule = (m: 'index' | 'bookpage' | 'estates') => !!S.office?.modules.includes(m);
export const cur = (): SeqItem | null => (S.seq && S.seq.items.length ? S.seq.items[S.idx] ?? null : null);
export const curPage = (): PageRef | null => cur()?.page ?? null;
export const form = (): FormState => S.forms[officeSlug()]!;
